import Vue from 'vue'
import Vuex from 'vuex'
import ui from './modules/ui'
import auth from './modules/auth'
import settings from './modules/settings'
import business from './modules/business'
import service from './modules/service'
import dropzone from './modules/dropzone'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    ui,
    auth,
    settings,
    business,
    service,
    dropzone
  }
})
